//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class RelationshipModel extends ModelBase {
      static readonly $typeName = 'RelationshipModel';
      public canDeleteRelationship: boolean;
      public isSourceConcept: boolean;
      public key: string;
      public relatedConcept: LookupModel;
      public relationshipType: LookupModel;
      public relationshipKey: string;
      public codeSystemVersion: LookupModel;
      
  }



// WEBPACK FOOTER //
// ./src/app/vocabulary/models/RelationshipModel.ts